export const WEEKDAY_OPTIONS = [
  { id: 0, translation_key: 'general_monday' },
  { id: 1, translation_key: 'general_tuesday' },
  { id: 2, translation_key: 'general_wednesday' },
  { id: 3, translation_key: 'general_thursday' },
  { id: 4, translation_key: 'general_friday' },
  { id: 5, translation_key: 'general_saturday' },
  { id: 6, translation_key: 'general_sunday' },
  { id: 7, translation_key: 'general_weekdays' },
  { id: 8, translation_key: 'general_weekend' },
]

export const SORTED_WEEKDAY_OPTIONS = [...WEEKDAY_OPTIONS].sort((a, b) => {
  // put 7 and 8 first
  const priority = [7, 8]
  if (priority.includes(a.id) && !priority.includes(b.id)) return -1
  if (!priority.includes(a.id) && priority.includes(b.id)) return 1
  return a.id - b.id // otherwise sort by normal weekday order
})
